$(function () {
    var $nav = $('#mainNav16');
    if (!$nav.length) return;

    var HOVER_DELAY = 250, LEAVE_DEBOUNCE = 50, COMMIT_DELAY = 180, CLOSE_MS = 80;
    var TOGGLE_CLOSE_DELAY = LEAVE_DEBOUNCE + HOVER_DELAY + 150;

    function clearLeaveTimers($el) {
        clearTimeout($el.data('hoverTimeout'));
        clearTimeout($el.data('hoverLeaveDelay'));
    }

    function cancelOpenBfadeClose() {
        $nav.find('.bfade.open').closest('.togglesecondary').each(function () { clearLeaveTimers($(this)); });
    }

    function openBfade($li) {
        var $bfade = $li.find('.bfade');
        if (!$bfade.length) return;
        var li = $li[0], bfade = $bfade[0], $toggle = $li.closest('ul.toggle');
        requestAnimationFrame(function () {
            $bfade.addClass('bfade-delay');
            bfade.offsetHeight;
            var liH = li.offsetHeight;
            var bfadeH = bfade.offsetHeight || bfade.scrollHeight;
            if (!bfadeH) bfadeH = bfade.getBoundingClientRect().bottom - bfade.getBoundingClientRect().top;
            var minTop = $toggle[0].getBoundingClientRect().top - li.getBoundingClientRect().top;
            var idealTop = bfadeH ? (liH / 2) - (bfadeH / 2) : minTop;
            $bfade.css('top', Math.round(Math.max(minTop, idealTop)) + 'px')
                .removeClass('bfade-delay bfade-measure').addClass('open');
        });
    }

    function closeBfade($b) {
        var s = (CLOSE_MS / 1000) + 's';
        $b.closest('.togglesecondary').removeClass('hover');
        $b.css({ transition: 'opacity ' + s + ' ease, visibility ' + s, transform: 'translateX(0)' });
        $b[0].offsetHeight;
        $b.one('transitionend', function (e) {
            if (e.originalEvent && e.originalEvent.propertyName === 'opacity') $b.css({ transition: '', transform: '' });
        }).removeClass('open');
    }

    function closeAllBfades() {
        $nav.find('.bfade.open').each(function () { closeBfade($(this)); });
    }

    function clearSiblingHover($except) {
        var $items = $except ? $nav.find('.togglesecondary').not($except) : $nav.find('.togglesecondary');
        $items.each(function () {
            var $el = $(this);
            clearLeaveTimers($el);
            clearTimeout($el.data('hoverIntent'));
            if (!$el.find('.bfade.open').length) $el.removeClass('hover');
        });
    }

    $nav.find('.no-js').removeClass('no-js');
    function closeToggle($t) {
        $t.find('.bfade.open').each(function () { closeBfade($(this)); });
        $t.removeClass('togactive');
        $t.one('transitionend', function (e) {
            if (e.originalEvent && (e.originalEvent.propertyName === 'opacity' || e.originalEvent.propertyName === 'transform')) {
                $t.css('display', '');
            }
        });
    }
    function openToggle($t) {
        $t.css('display', 'block');
        $t[0].offsetHeight;
        $t.addClass('togactive');
        var $bfades = $t.find('.bfade');
        $bfades.addClass('bfade-measure');
        $bfades[0] && $bfades[0].offsetHeight;
        $bfades.removeClass('bfade-measure');
    }
    function closeAllToggles() {
        $nav.find('.titleactive').removeClass('titleactive');
        $nav.find('.togactive').each(function () { closeToggle($(this)); });
    }

    $nav.on('click', 'ul.navtopul > li.has-children > span', function (e) {
        var $span = $(this), $parent = $span.parent();
        $parent.siblings().removeClass('titleactive');
        $parent.toggleClass('titleactive');
        $parent.siblings().find('ul.toggle.togactive').each(function () { closeToggle($(this)); });
        var $toggle = $span.next('ul.toggle');
        if ($parent.hasClass('titleactive')) {
            openToggle($toggle);
        } else {
            closeToggle($toggle);
        }
        e.stopPropagation();
    });

    $(document).on('click', function () { closeAllToggles(); });

    function isOverNav(x, y) {
        var el = document.elementFromPoint(x, y);
        return el && $.contains($nav[0], el);
    }

    var lastMove = 0, lastX = 0, lastY = 0;
    $(document).on('mousemove.navclose', function (e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (!$nav.find('.togactive').length) return;
        var now = Date.now();
        if (now - lastMove < 80) return;
        lastMove = now;
        if (isOverNav(lastX, lastY)) {
            clearTimeout($nav.data('toggleCloseTimer'));
            $nav.removeData('toggleCloseTimer');
        } else if (!$nav.data('toggleCloseTimer')) {
            $nav.data('toggleCloseTimer', setTimeout(function () {
                $nav.removeData('toggleCloseTimer');
                closeAllToggles();
            }, TOGGLE_CLOSE_DELAY));
        }
    });

    $nav.on('mouseleave', function (e) {
        if (!e.relatedTarget || !$.contains($nav[0], e.relatedTarget)) {
            setTimeout(function () {
                if (!isOverNav(lastX, lastY) && !$nav.data('toggleCloseTimer')) {
                    $nav.data('toggleCloseTimer', setTimeout(function () {
                        $nav.removeData('toggleCloseTimer');
                        closeAllToggles();
                    }, TOGGLE_CLOSE_DELAY));
                }
            }, 50);
        }
    }).on('mouseenter', function () {
        clearTimeout($nav.data('toggleCloseTimer'));
        $nav.removeData('toggleCloseTimer');
    });

    $nav.on('mouseenter', '.togglesecondary', function () {
        var $this = $(this), $bfade = $this.find('.bfade');
        clearLeaveTimers($this);
        clearTimeout($this.data('hoverIntent'));
        clearTimeout($this.data('hoverCommit'));
        if ($this.hasClass('hover')) return;
        clearSiblingHover($this);
        if (!$bfade.length) {
            cancelOpenBfadeClose();
            setTimeout(cancelOpenBfadeClose, 60);
            $this.data('hoverCommit', setTimeout(function () {
                closeAllBfades();
                $this.addClass('hover');
            }, COMMIT_DELAY));
            return;
        }
        $bfade.addClass('bfade-measure');
        $this.data('hoverIntent', setTimeout(function () {
            if ($this.hasClass('hover')) return;
            closeAllBfades();
            openBfade($this);
            $this.addClass('hover');
        }, HOVER_DELAY));
    }).on('mouseenter', '.bfade', function () {
        var $li = $(this).closest('.togglesecondary');
        if ($li.length) { clearLeaveTimers($li); $li.addClass('hover'); }
    }).on('mouseleave', '.togglesecondary', function (e) {
        var $this = $(this);
        clearTimeout($this.data('hoverIntent'));
        clearLeaveTimers($this);
        clearTimeout($this.data('hoverCommit'));
        $this.find('.bfade').removeClass('bfade-measure');
        if ($this.find('.bfade.open').length && e.relatedTarget) {
            var $to = $(e.relatedTarget).closest('.togglesecondary, .bfade');
            if ($to.length && ($to.hasClass('bfade') || !$to.find('.bfade').length)) return;
        }
        $this.data('hoverLeaveDelay', setTimeout(function () {
            $this.data('hoverTimeout', setTimeout(function () {
                var $b = $this.find('.bfade');
                $b.length ? closeBfade($b) : $this.removeClass('hover');
            }, HOVER_DELAY));
        }, LEAVE_DEBOUNCE));
    });

    if ('ontouchstart' in document.documentElement) {
        var closeDropdownFn = null;
        $nav.on('touchstart', '.togglesecondary', function (e) {
            if (e.touches.length !== 1) return;
            e.stopPropagation();
            var $this = $(this);
            if (!$this.hasClass('hover')) {
                if (e.target === this || e.target.parentNode === this) e.preventDefault();
                clearSiblingHover();
                closeAllBfades();
                $this.addClass('hover');
                openBfade($this);
                if (closeDropdownFn) document.removeEventListener('touchstart', closeDropdownFn);
                closeDropdownFn = function (ev) {
                    ev.stopPropagation();
                    clearSiblingHover();
                    closeAllBfades();
                    document.removeEventListener('touchstart', closeDropdownFn);
                    closeDropdownFn = null;
                };
                document.addEventListener('touchstart', closeDropdownFn, { passive: false });
            }
        });
    }
});
